import { useIntl } from "react-intl";

import { JswCollaborate } from "./components";
import {
    getCollaborateFirstImage,
    getCollaborateFourthImage,
    getCollaborateSecondImage,
    getCollaborateThirdImage
} from "./components/assets/localized-images";

export const JswCollaborateSection = () => {
    const intl = useIntl();

    const options = [
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.first-feature-title-text",
                defaultMessage: "⚡ Plan and organize tasks"
            }),
            image: getCollaborateFirstImage(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.first-feature-description-text",
                defaultMessage:
                    "From short projects, to large cross-functional programs, Jira helps break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more."
            })
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-title-text",
                defaultMessage: "Align work to goals"
            }),
            image: getCollaborateSecondImage(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.second-feature-description-text",
                defaultMessage:
                    "Link work to goals so everyone can see how their work contributes to company objectives and stay aligned to what’s important."
            })
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.third-feature-title-text",
                defaultMessage: "Track work your way"
            }),
            image: getCollaborateThirdImage(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.third-feature-description-text",
                defaultMessage:
                    "Visualize work with lists, boards, backlogs, and more. Make workflows for any process and integrate with tools you love."
            })
        },
        {
            title: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.fourth-feature-title-text",
                defaultMessage: "Optimize with insights"
            }),
            image: getCollaborateFourthImage(intl.locale),
            description: intl.formatMessage({
                id: "jira-product-tour.collaborate-section.fourth-feature-description-text",
                defaultMessage:
                    "Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance."
            })
        }
    ];

    return (
        <JswCollaborate
            options={options}
            heading={intl.formatMessage({
                id: "jira-product-tour.collaborate-section.title-text",
                defaultMessage: "Made for complex projects or everyday tasks"
            })}
        />
    );
};
JswCollaborateSection.displayName = "JswCollaborateSection";
